class SimpleSubscriptionWidget extends HTMLElement {
    constructor() {
      super();
      this.currentVariantId = null;
      this.currentPrice = null;
      this.currentSellingPlanId = null;
      this.translations = this.getTranslations();
    }

    getTranslations() {
      const htmlLang = document.documentElement.lang || 'nl';
      const shopLocale = window.Shopify?.locale || 'nl';
      const currentLang = htmlLang.includes('de') ? 'de' : 
                         htmlLang.includes('en') ? 'en' : 'nl';
      
      const translations = {
        nl: {
          onetime: "Eenmalige aankoop",
          subscription: "Abonnement",
          productTitle: "Beauty Collageen met Verisol®",
          freeShipping: "Gratis verzending",
          cancelAnyTime: "Elk moment opzegbaar",
          youSave: "Je bespaart",
          perMonth: "per maand",
          perTwoMonths: "per twee maanden", 
          perThreeMonths: "per drie maanden",
          sachets: "zakjes"
        },
        de: {
          onetime: "Einmaliger Kauf",
          subscription: "Abonnement", 
          productTitle: "Beauty Collagen mit Verisol®",
          freeShipping: "Kostenloser Versand",
          cancelAnyTime: "Jederzeit kündbar",
          youSave: "Sie sparen",
          perMonth: "pro Monat",
          perTwoMonths: "alle zwei Monate",
          perThreeMonths: "alle drei Monate",
          sachets: "Beutel"
        },
        en: {
          onetime: "One-time purchase",
          subscription: "Subscription",
          productTitle: "Beauty Collagen with Verisol®",
          freeShipping: "Free shipping",
          cancelAnyTime: "Cancel anytime",
          youSave: "You save",
          perMonth: "per month",
          perTwoMonths: "every two months",
          perThreeMonths: "every three months", 
          sachets: "sachets"
        }
      };
      
      return translations[currentLang] || translations.nl;
    }
  
    connectedCallback() {
      this.init();
    }
  
    init() {
      this.appendSellingPlanInputs();
      this.setupRadioButtonListeners();
      this.setupPurchaseTypeListeners();
      
      // Select one-time purchase as default
      const onetimeToggle = this.querySelector('input[type="radio"][value="onetime"]');
      if (onetimeToggle) {
        onetimeToggle.checked = true;
        onetimeToggle.dispatchEvent(new Event('change', { bubbles: true }));
      }
      
      // Then select first one-time purchase option
      const firstOnetimeRadio = this.querySelector('input[type="radio"][data-radio-type="otp"]');
      if (firstOnetimeRadio) {
        firstOnetimeRadio.checked = true;
        firstOnetimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  
    setupPurchaseTypeListeners() {
      this.addEventListener('change', (event) => {
        const target = event.target;
        
        if (target.type === 'radio' && target.name && target.name.includes('purchase-type')) {
          this.handlePurchaseTypeChange(target.value);
        }
      });
    }
  
    handlePurchaseTypeChange(purchaseType) {
      let targetRadio = null;
      
      if (purchaseType === 'subscription') {
        targetRadio = this.querySelector('input[type="radio"][data-radio-type="selling_plan"]');
      } else if (purchaseType === 'onetime') {
        targetRadio = this.querySelector('input[type="radio"][data-radio-type="otp"]');
      }
      
      if (targetRadio) {
        targetRadio.checked = true;
        targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  
    setupRadioButtonListeners() {
      this.addEventListener('change', (event) => {
        const target = event.target;
        
        if (target.type === 'radio' && target.hasAttribute('data-selling-plan-id')) {
          this.updateSellingPlanInputsValues(target.dataset.sellingPlanId);
          this.updateVariantIdInputsValues(target.dataset.variantId);
        }
      });
    }
  
    appendSellingPlanInputs() {
      this.addToCartForms.forEach((addToCartForm) => {
        if (!addToCartForm.querySelector('input[name="selling_plan"], select[name="selling_plan"]')) {
          const input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'selling_plan';
          input.className = 'selected-selling-plan-id';
          addToCartForm.appendChild(input);
        }
      });
    }
  
    get addToCartForms() {
      return [...this.shopifySection.querySelectorAll('input[name="form_type"][value="product"]')]
        .map(input => input.closest('form'));
    }
  
    get shopifySection() {
      return document.querySelector(`#shopify-section-${this.sectionId}`);
    }
  
    get sectionId() {
      return this.getAttribute('data-section-id');
    }
  
    get sellingPlanInputs() {
      return this.shopifySection.querySelectorAll('.selected-selling-plan-id');
    }
  
    get variantIdInputs() {
      return this.addToCartForms.flatMap(form => 
        [...form.querySelectorAll(`input[name="id"], select[name="id"]`)]
      );
    }
  
    updateSellingPlanInputsValues(sellingPlanId) {
      this.triggerSellingPlanChangedEvent();
      this.sellingPlanInputs.forEach((input) => {
        input.value = sellingPlanId || '';
      });
    }
  
    updateVariantIdInputsValues(variantId) {
      this.triggerSellingPlanChangedEvent();
      this.variantIdInputs.forEach((input) => {
        input.value = variantId || '';
      });
    }
  
    triggerSellingPlanChangedEvent() {
      const selectedRadio = this.querySelector('input[type="radio"]:checked');
      if (!selectedRadio) return;
  
      const variantId = selectedRadio.dataset.variantId;
      const price = selectedRadio.dataset.price;
      const sellingPlanId = selectedRadio.dataset.sellingPlanId;
  
      if (variantId === this.currentVariantId && 
          price === this.currentPrice && 
          sellingPlanId === this.currentSellingPlanId) {
        return;
      }
  
      this.currentVariantId = variantId;
      this.currentPrice = price;
      this.currentSellingPlanId = sellingPlanId;
  
      const event = new CustomEvent('firmhouse.sellingPlanChanged', {
        bubbles: true,
        detail: {
          variantId: variantId,
          price: price ?? null,
          sellingPlanId: sellingPlanId ?? null
        }
      });
      this.dispatchEvent(event);
    }
  }
  
  // Register the custom element - PREVENT DOUBLE REGISTRATION
  if (!customElements.get('simple-subscription-widget')) {
    customElements.define('simple-subscription-widget', SimpleSubscriptionWidget);
  }

document.addEventListener("DOMContentLoaded", () => {
  // Prevent double execution
  if (window.subscriptionWidgetInitialized) {
    return;
  }
  window.subscriptionWidgetInitialized = true;

  function getTranslations() {
    const htmlLang = document.documentElement.lang || 'nl';
    const shopLocale = window.Shopify?.locale || 'nl';
    const currentLang = htmlLang.includes('de') ? 'de' : 
                       htmlLang.includes('en') ? 'en' : 'nl';
    
    const translations = {
      nl: {
        onetime: "Eenmalige aankoop",
        subscription: "Abonnement",
        productTitle: "Beauty Collageen met Verisol®",
        freeShipping: "Gratis verzending",
        cancelAnyTime: "Elk moment opzegbaar",
        youSave: "Je bespaart",
        perMonth: "per maand",
        perTwoMonths: "per twee maanden", 
        perThreeMonths: "per drie maanden",
        sachets: "zakjes"
      },
      de: {
        onetime: "Einmaliger Kauf",
        subscription: "Abonnement", 
        productTitle: "Beauty Collagen mit Verisol®",
        freeShipping: "Kostenloser Versand",
        cancelAnyTime: "Jederzeit kündbar",
        youSave: "Sie sparen",
        perMonth: "pro Monat",
        perTwoMonths: "alle zwei Monate",
        perThreeMonths: "alle drei Monate",
        sachets: "Beutel"
      },
      en: {
        onetime: "One-time purchase",
        subscription: "Subscription",
        productTitle: "Beauty Collagen with Verisol®",
        freeShipping: "Free shipping",
        cancelAnyTime: "Cancel anytime",
        youSave: "You save",
        perMonth: "per month",
        perTwoMonths: "every two months",
        perThreeMonths: "every three months", 
        sachets: "sachets"
      }
    };
    
    return translations[currentLang] || translations.nl;
  }

  const translations = getTranslations();

  // Add mobile spacing fix CSS + WHITE BACKGROUND FIX + CLICKABILITY FIX
  const mobileFixCSS = document.createElement('style');
  mobileFixCSS.textContent = `
    /* NUCLEAR MOBILE PADDING FIX - BEIDE SECTIONS IDENTISCH */
    @media (max-width: 768px) {
      /* BEIDE SECTIONS - SUBSCRIPTION UND ONETIME - IDENTISCHE PADDING WERTE */
      body simple-subscription-widget .subscription-section,
      body simple-subscription-widget .subscription-section .subscription-plans-list,
      body simple-subscription-widget .onetime-section,
      body simple-subscription-widget .onetime-section .otp-list {
        margin: 0 !important;
        padding: 0 !important;
        width: 100% !important;
        max-width: 100% !important;
      }
      
      body simple-subscription-widget {
        margin: 0 !important;
        padding: 0.5rem !important;
        width: 100% !important;
      }
      
      /* SUBSCRIPTION BEHÄLT SEIN PADDING */
      body simple-subscription-widget .subscription-section .option-card {
        margin: 0 !important;
        padding: 1.5rem !important;
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
      }
      
      /* ONE-TIME BEKOMMT MEHR PADDING UM WIE SUBSCRIPTION AUSZUSEHEN */
      body simple-subscription-widget .onetime-section .option-card {
        margin: 0 !important;
        padding: 1.5rem 1.5rem !important; /* MEHR SEITLICHES PADDING */
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
      }
      
      /* KILL ALLE FLEXBOX PROPERTIES - BEIDE SECTIONS */
      body simple-subscription-widget .subscription-section .option-header,
      body simple-subscription-widget .onetime-section .option-header,
      body simple-subscription-widget .subscription-section .option-pricing,
      body simple-subscription-widget .onetime-section .option-pricing {
        display: block !important;
        position: static !important;
        margin: 0 !important;
        padding: 0 !important;
      }
      
      /* RADIO BUTTONS VERSTECKT */
      body simple-subscription-widget input[type="radio"] {
        display: none !important;
        visibility: hidden !important;
        opacity: 0 !important;
        position: absolute !important;
        left: -9999px !important;
      }
    }
    
    /* WEISSE HINTERGRÜNDE FÜR NICHT-AUSGEWÄHLTE TOGGLE BUTTONS + GRÖßERE SCHRIFT */
    simple-subscription-widget .switch-label {
      background-color: white !important;
      background: white !important;
      font-size: 1.15em !important;
    }
    
    /* AUSGEWÄHLTE BUTTONS BLEIBEN WIE SIE SIND (BLAU) + GRÖßERE SCHRIFT */
    simple-subscription-widget input[type="radio"][value="subscription"]:checked ~ .purchase-type-switch .subscription-label,
    simple-subscription-widget input[type="radio"][value="onetime"]:checked ~ .purchase-type-switch .onetime-label {
      background: rgb(var(--accent)) !important;
      color: white !important;
      box-shadow: 0 2px 4px rgba(59, 130, 246, 0.3) !important;
      font-size: 1.15em !important;
    }
    
    /* CLICKABILITY FIX - ALLE OPTION CARDS MÜSSEN KLICKBAR SEIN */
    simple-subscription-widget .option-card {
      cursor: pointer !important;
      pointer-events: auto !important;
      position: relative !important;
      z-index: 1 !important;
    }
    
    /* ENSURE ALL NESTED ELEMENTS DON'T BLOCK CLICKS */
    simple-subscription-widget .option-card * {
      pointer-events: none !important;
    }
    
    /* BUT RADIO INPUTS NEED TO BE CLICKABLE */
    simple-subscription-widget .option-card input[type="radio"] {
      pointer-events: auto !important;
    }
  `;
  mobileFixCSS.setAttribute('data-mobile-spacing-fix', 'true');
  document.head.insertBefore(mobileFixCSS, document.head.firstChild);

  // FIX: Add click handlers to make ALL option cards clickable
  const addClickHandlers = () => {
    const allOptionCards = document.querySelectorAll('simple-subscription-widget .option-card');
    
    allOptionCards.forEach((card, index) => {
      // Remove existing click handlers to prevent duplicates
      card.removeEventListener('click', handleCardClick);
      
      // Add click handler
      card.addEventListener('click', handleCardClick);
      
      // Debug: Mark which card this is
      card.setAttribute('data-card-index', index);
    });
  };
  
  const handleCardClick = (event) => {
    event.preventDefault();
    event.stopPropagation();
    
    const card = event.currentTarget;
    const radioInput = card.querySelector('input[type="radio"]');
    
    if (radioInput && !radioInput.checked) {
      radioInput.checked = true;
      radioInput.dispatchEvent(new Event('change', { bubbles: true }));
      
      // Debug log
      console.log('Clicked card:', card.getAttribute('data-card-index'), 'Radio:', radioInput.value || radioInput.dataset.variantId);
    }
  };
  
  // Apply click handlers initially
  addClickHandlers();
  
  // Re-apply click handlers after a short delay to catch dynamically loaded content
  setTimeout(addClickHandlers, 500);
  setTimeout(addClickHandlers, 1000);

  // Handle One-Time Purchase boxes
  const onetimeBoxes = document.querySelectorAll(
    'simple-subscription-widget .onetime-section .option-card'
  );
  
  const onetimeBoxData = [
    {
      price: "€39,95",
      qty: "30"
    },
    {
      original: "€79,90",
      price: "€72,95",
      savings: "6,95",
      qty: "60"
    },
    {
      original: "€119,85",
      price: "€99,95",
      savings: "19,90",
      qty: "90"
    }
  ];

  // Handle Subscription boxes
  const subscriptionBoxes = document.querySelectorAll(
    'simple-subscription-widget .subscription-section .option-card'
  );
  
  const subscriptionBoxData = [
    {
      original: "€39,95",
      price: "€37,95",
      savings: "2",
      qty: "30",
      frequency: translations.perMonth
    },
    {
      original: "€72,95",
      price: "€67,95",
      savings: "5",
      qty: "60",
      frequency: translations.perTwoMonths
    },
    {
      original: "€99,95",
      price: "€89,95",
      savings: "10",
      qty: "90",
      frequency: translations.perThreeMonths
    }
  ];

  // Process One-Time Purchase boxes
  onetimeBoxes.forEach((box, i) => {
    const data = onetimeBoxData[i];
    if (!data) return;

    const content = box.querySelector(".option-content");
    const priceBox = box.querySelector(".option-pricing");
    const titleEl = box.querySelector(".option-title");

    // Skip if already processed
    if (box.querySelector(".onetime-processed")) return;

    // Remove any existing product titles from content area
    const existingTitle = content.querySelector(".product-title");
    if (existingTitle) {
      existingTitle.remove();
    }

    // Create layout with IDENTICAL structure as subscription boxes
    if (titleEl && priceBox) {
      const hasSavings = typeof data.original === "string" && data.original.trim() !== "" && typeof data.savings === "string" && data.savings.trim() !== "";
      
      // Clear existing content
      titleEl.innerHTML = "";
      priceBox.innerHTML = "";
      
      // WRAPPER FÜR ONETIME - IDENTISCH WIE SUBSCRIPTION
      const onetimeWrapper = document.createElement("div");
      onetimeWrapper.style.cssText = "width: 100% !important; max-width: 100% !important; margin: 0 !important; padding: 0 !important; box-sizing: border-box !important; position: relative !important;";
      
      // Create the complete layout structure - IDENTISCHE STRUKTUR WIE SUBSCRIPTION
      const completeContainer = document.createElement("div");
      completeContainer.style.cssText = "display: flex !important; flex-direction: column !important; gap: 0.2rem !important; margin: 0 !important; padding: 0 !important; width: 100% !important;";
      
      // Top row: Product title + original price (only if has savings)
      const titleRow = document.createElement("div");
      titleRow.style.cssText = "display: flex !important; justify-content: space-between !important; align-items: center !important; margin: 0 !important; margin-bottom: 0.2rem !important; padding: 0 !important; width: 100% !important;";
      
      const productTitle = document.createElement("div");
      productTitle.style.cssText = "font-weight: 600 !important; font-size: 0.95rem !important; line-height: 1.1 !important; margin: 0 !important; padding: 0 !important;";
      productTitle.textContent = translations.productTitle;
      titleRow.appendChild(productTitle);
      
      if (hasSavings) {
        const originalPrice = document.createElement("div");
        originalPrice.style.cssText = "font-size: 0.9rem !important; color: #ff0000 !important; text-decoration: line-through !important; line-height: 1.1 !important; font-weight: normal !important; margin: 0 !important; padding: 0 !important;";
        originalPrice.textContent = data.original;
        titleRow.appendChild(originalPrice);
      }
      
      completeContainer.appendChild(titleRow);
      
      // Main row: IDENTISCHE GRID STRUKTUR WIE SUBSCRIPTION
      const mainRow = document.createElement("div");
      mainRow.style.cssText = "display: grid !important; grid-template-columns: 1fr auto !important; gap: 0.5rem !important; align-items: start !important; width: 100% !important; margin: 0 !important; padding: 0 !important;";
      
      // Left side: sachets + free shipping - IDENTISCH WIE SUBSCRIPTION
      const leftSide = document.createElement("div");
      leftSide.style.cssText = "display: flex !important; flex-direction: column !important; gap: 0.2rem !important; margin: 0 !important; padding: 0 !important; justify-self: start !important;";
      
      // Sachets - IDENTISCHE STYLING WIE SUBSCRIPTION
      const sachetsEl = document.createElement("div");
      sachetsEl.style.cssText = "font-weight: 600 !important; font-size: 0.85rem !important; line-height: 1.1 !important; margin: 0 !important; padding: 0 !important;";
      sachetsEl.textContent = `${data.qty} ${translations.sachets}`;
      leftSide.appendChild(sachetsEl);
      
      // Bulletpoints container - IDENTISCH WIE SUBSCRIPTION
      const bulletContainer = document.createElement("div");
      bulletContainer.style.cssText = "display: flex !important; flex-direction: column !important; gap: 0.15rem !important; font-size: 0.9rem !important; color: #444 !important; margin: 0 !important; padding: 0 !important;";
      
      const bulletPoints = [`› ${translations.freeShipping}`];
      
      bulletPoints.forEach(bullet => {
        const bulletEl = document.createElement("div");
        bulletEl.style.cssText = "font-weight: 400 !important; line-height: 1.1 !important; margin: 0 !important; padding: 0 !important;";
        bulletEl.textContent = bullet;
        bulletContainer.appendChild(bulletEl);
      });
      
      leftSide.appendChild(bulletContainer);
      
      // Right side: current price + savings - IDENTISCH WIE SUBSCRIPTION
      const rightSide = document.createElement("div");
      rightSide.style.cssText = "display: flex !important; flex-direction: column !important; align-items: flex-end !important; gap: 0.2rem !important; margin: 0 !important; padding: 0 !important; justify-self: end !important; text-align: right !important;";
      
      // Current price - IDENTISCHE STYLING WIE SUBSCRIPTION
      const currentPrice = document.createElement("div");
      currentPrice.style.cssText = "font-weight: 600 !important; font-size: 1.2rem !important; line-height: 1.1 !important; text-align: right !important; margin: 0 !important; padding: 0 !important; white-space: nowrap !important;";
      currentPrice.textContent = data.price;
      rightSide.appendChild(currentPrice);
      
      // Savings text (only if has savings) - IDENTISCHE STRUKTUR WIE SUBSCRIPTION
      if (hasSavings) {
        // Spacer to align with bulletpoints - IDENTISCH WIE SUBSCRIPTION  
        const spacer = document.createElement("div");
        spacer.style.cssText = "height: 0.2rem !important; margin: 0 !important; padding: 0 !important;";
        rightSide.appendChild(spacer);
        
        const savingsEl = document.createElement("div");
        savingsEl.style.cssText = "color: #0f766e !important; font-size: 0.9rem !important; font-weight: 400 !important; line-height: 1.1 !important; text-align: right !important; margin: 0 !important; padding: 0 !important; white-space: nowrap !important;";
        savingsEl.textContent = `${translations.youSave} €${data.savings}`;
        rightSide.appendChild(savingsEl);
      } else {
        // WICHTIG: Auch ohne Savings einen Spacer hinzufügen für gleiche Höhe wie Subscription
        const spacer = document.createElement("div");
        spacer.style.cssText = "height: 1.35rem !important; margin: 0 !important; padding: 0 !important;"; // Gleiche Höhe wie bei Subscription bulletpoints
        rightSide.appendChild(spacer);
      }
      
      mainRow.appendChild(leftSide);
      mainRow.appendChild(rightSide);
      completeContainer.appendChild(mainRow);
      
      onetimeWrapper.appendChild(completeContainer);
      titleEl.appendChild(onetimeWrapper);
    }

    // Mark as processed
    const marker = document.createElement("div");
    marker.className = "onetime-processed";
    marker.style.display = "none";
    box.appendChild(marker);
  });

  // Process Subscription boxes - WITH FREQUENCY TEXT ADDED
  subscriptionBoxes.forEach((box, i) => {
    const data = subscriptionBoxData[i];
    if (!data) return;

    const content = box.querySelector(".option-content");
    const priceBox = box.querySelector(".option-pricing");
    const titleEl = box.querySelector(".option-title");

    // Skip if already processed
    if (box.querySelector(".subscription-processed")) return;

    // Remove the original product title from content area
    const existingTitle = content.querySelector(".product-title");
    if (existingTitle) {
      existingTitle.remove();
    }

    // Remove ALL existing bulletpoints and savings texts from content area
    const allSavingsTexts = content.querySelectorAll('[style*="color: #0f766e"], [style*="color:#0f766e"]');
    allSavingsTexts.forEach(el => el.remove());
    
    const allElements = content.querySelectorAll('*');
    allElements.forEach(el => {
      if (el.textContent && (el.textContent.includes(translations.youSave) || 
          el.textContent.includes(translations.freeShipping) || 
          el.textContent.includes(translations.cancelAnyTime))) {
        if (!el.classList.contains('product-title')) {
          el.remove();
        }
      }
      // Remove duplicate sachets
      if (el.textContent && el.textContent.trim().match(/^\d+\s+(zakjes|Beutel|sachets)$/) && el.style.fontWeight !== "600") {
        el.remove();
      }
    });

    // FIXED layout restructure for subscription boxes WITH FREQUENCY
    if (titleEl && priceBox) {
      // Clear existing content
      titleEl.innerHTML = "";
      priceBox.innerHTML = "";
      
      // WRAPPER FÜR SUBSCRIPTION
      const subscriptionWrapper = document.createElement("div");
      subscriptionWrapper.style.cssText = "width: 100% !important; max-width: 100% !important; margin: 0 !important; padding: 0 !important; box-sizing: border-box !important; position: relative !important;";
      
      // Create the complete layout structure
      const completeContainer = document.createElement("div");
      completeContainer.style.cssText = "display: flex !important; flex-direction: column !important; gap: 0.2rem !important; margin: 0 !important; padding: 0 !important; width: 100% !important;";
      
      // Top row: Product title + original price
      const titleRow = document.createElement("div");
      titleRow.style.cssText = "display: flex !important; justify-content: space-between !important; align-items: center !important; margin: 0 !important; margin-bottom: 0.2rem !important; padding: 0 !important; width: 100% !important;";
      
      const productTitle = document.createElement("div");
      productTitle.style.cssText = "font-weight: 600 !important; font-size: 0.95rem !important; line-height: 1.1 !important; margin: 0 !important; padding: 0 !important;";
      productTitle.textContent = translations.productTitle;
      
      const originalPrice = document.createElement("div");
      originalPrice.style.cssText = "font-size: 0.9rem !important; color: #ff0000 !important; text-decoration: line-through !important; line-height: 1.1 !important; font-weight: normal !important; margin: 0 !important; padding: 0 !important;";
      originalPrice.textContent = data.original;
      
      titleRow.appendChild(productTitle);
      titleRow.appendChild(originalPrice);
      completeContainer.appendChild(titleRow);
      
      // Main row with grid
      const mainRow = document.createElement("div");
      mainRow.style.cssText = "display: grid !important; grid-template-columns: 1fr auto !important; gap: 0.5rem !important; align-items: start !important; width: 100% !important; margin: 0 !important; padding: 0 !important;";
      
      // Left side: sachets + frequency + bulletpoints
      const leftSide = document.createElement("div");
      leftSide.style.cssText = "display: flex !important; flex-direction: column !important; gap: 0.2rem !important; margin: 0 !important; padding: 0 !important; justify-self: start !important;";
      
      // Sachets + frequency in one line
      const sachetsEl = document.createElement("div");
      sachetsEl.style.cssText = "font-weight: 600 !important; font-size: 0.85rem !important; line-height: 1.1 !important; margin: 0 !important; padding: 0 !important;";
      sachetsEl.textContent = `${data.qty} ${translations.sachets} ${data.frequency}`;
      leftSide.appendChild(sachetsEl);
      
      // Bulletpoints container
      const bulletContainer = document.createElement("div");
      bulletContainer.style.cssText = "display: flex !important; flex-direction: column !important; gap: 0.15rem !important; font-size: 0.9rem !important; color: #444 !important; margin: 0 !important; padding: 0 !important;";
      
      const bulletPoints = [
        `› ${translations.freeShipping}`,
        `› ${translations.cancelAnyTime}`
      ];
      
      bulletPoints.forEach(bullet => {
        const bulletEl = document.createElement("div");
        bulletEl.style.cssText = "font-weight: 400 !important; line-height: 1.1 !important; margin: 0 !important; padding: 0 !important;";
        bulletEl.textContent = bullet;
        bulletContainer.appendChild(bulletEl);
      });
      
      leftSide.appendChild(bulletContainer);
      
      // Right side: prices
      const rightSide = document.createElement("div");
      rightSide.style.cssText = "display: flex !important; flex-direction: column !important; align-items: flex-end !important; gap: 0.2rem !important; margin: 0 !important; padding: 0 !important; justify-self: end !important; text-align: right !important;";
      
      // Current price
      const currentPrice = document.createElement("div");
      currentPrice.style.cssText = "font-weight: 600 !important; font-size: 1.2rem !important; line-height: 1.1 !important; text-align: right !important; margin: 0 !important; padding: 0 !important; white-space: nowrap !important;";
      currentPrice.textContent = data.price;
      rightSide.appendChild(currentPrice);
      
      // Spacer to align with bulletpoints
      const spacer = document.createElement("div");
      spacer.style.cssText = "height: 0.2rem !important; margin: 0 !important; padding: 0 !important;";
      rightSide.appendChild(spacer);
      
      // Savings text
      if (data.savings) {
        const savingsEl = document.createElement("div");
        savingsEl.style.cssText = "color: #0f766e !important; font-size: 0.9rem !important; font-weight: 400 !important; line-height: 1.1 !important; text-align: right !important; margin: 0 !important; padding: 0 !important; white-space: nowrap !important;";
        savingsEl.textContent = `${translations.youSave} €${data.savings}`;
        rightSide.appendChild(savingsEl);
      }
      
      mainRow.appendChild(leftSide);
      mainRow.appendChild(rightSide);
      completeContainer.appendChild(mainRow);
      
      subscriptionWrapper.appendChild(completeContainer);
      titleEl.appendChild(subscriptionWrapper);
    }

    // Mark as processed
    const marker = document.createElement("div");
    marker.className = "subscription-processed";
    marker.style.display = "none";
    box.appendChild(marker);
  });
  
  // RE-APPLY CLICK HANDLERS AFTER PROCESSING BOXES
  setTimeout(() => {
    addClickHandlers();
    console.log('Click handlers re-applied after box processing');
  }, 100);
});